import React, {Component} from 'react'
import './MessengerMarker.scss'

export default class MessengerMarker extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps, nextContext) {

    }

    render() {
        const rotateDegress = (this.props.bearing + 270) % 360;

        return (
            <div style={{
                transform: `rotate(${rotateDegress}deg)` + ((rotateDegress > 90 && rotateDegress < 270) ? ' scale(1, -1)' : '')
            }}>
                {this.props.messengerIcon}
            </div>
        )
    }
}